<script>
  import { Line } from 'vue-chartjs'

  export default {
    extends: Line,
    data () {
      return {
        plotgraph : [],
        datacollection : null ,
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }],
            xAxes: [ {
              gridLines: {
                display: false
              }
            }]
          },
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    mounted () {
      this.put_data()
    },
    methods:{
      
      put_data(){

            const vm = this;
            vm.axios.get('https://ws.plantifulbkk.shop/get_sale_chart2.php').then(response => {
            var result = JSON.parse(JSON.stringify(response.data))

                      vm.datacollection =  {
                      labels: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'],
                      datasets: [
                      {
                        label: 'Current Month',
                        backgroundColor: '#bee6d2',
                        pointBackgroundColor: 'white',
                        borderWidth: 1,
                        pointBorderColor: '#249EBF',
                        data: response.data
                      },                      
                      {
                        label: 'Previous Month',
                        backgroundColor: '#f0edeb',
                        pointBackgroundColor: 'white',
                        borderWidth: 1,
                        pointBorderColor: '#249EBF',
                        data: [0,2,0,0,4,0,0,0,0,0,0,0,0,0,0,3,3,4,2,0,0,4,0,0,0,0,0,0,0]
                      }
                    ]
                  }

                  console.log(vm.datacollection )
                  vm.renderChart(this.datacollection, this.options)

            });

            

      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/statistics/LineChart.vue